import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './en.json'

/**
 * English only, deliberately.
 *
 * The Vue app shipped 21 locales and a language picker. The audience of this
 * product is an agent calling the API, and the twenty non-English catalogues were
 * translated once and then drifted; keeping the machinery for them would mean
 * every new string is either translated 20 times or visibly missing. i18next stays
 * because externalised strings are still the right shape for the messages the API
 * error table maps onto, and because adding a locale later is then a data change.
 */
export const resources = { en: { translation: en } } as const

export const defaultNS = 'translation'

void i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  // i18next prints a sponsorship notice to `console.info` on init. Nothing is
  // wrong, but it shows up in the browser console of every page and above the
  // output of every test file that touches a translation.
  showSupportNotice: false,
  defaultNS,
  interpolation: {
    // React escapes for us, and double-escaping mangles anything with an
    // apostrophe -- which is most of the error descriptions.
    escapeValue: false,
  },
})

export default i18n
